<template>
  <div class="basicBox">
    <div class="goodsBox" v-for="(item,index) of zxcy" :key="index">
      <div class="imgbox">
        <img :src="item.src" alt="">
      </div>
      <Title :title="item.name" fontSize="16px" color="#313132" height="20px" lineHeight="20px" class="title"></Title>
      <div class="desBox">
        <div class="desc" >{{item.pzwh}}</div>
        <div class="desc" >{{item.gg}}</div>
        <div class="desc" >{{item.scqy}}</div>
        <div class="desc" >{{item.gnzz}}</div>
        <div class="desc" >{{item.yl}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from 'components/Title.vue'
import {zxcy} from '../utils/newItems'
export default {
  name: 'Zxcy',
  components: {
    Title,
  },
  data(){
    return{
      zxcy,
    }
  },
  methods:{

  }
}
</script>
<style scoped lang="less">
.basicBox{
  margin: 0;
  width: 70%;
  padding: 50px 15% 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  // align-content: space-between;
  .goodsBox{
    cursor: pointer;
    width: 30%;
    text-align: center;
    margin: 40px 20px;
    
    .imgbox{
      width: 100%;
      height: 260px;
      border: 1px solid #939396;
      margin-bottom: 30px;
      img{
        width: 60%;
        height: auto;
      }
    }
    .desBox{
      height:120px;
      .title{
        width: 100%;
      }
      .desc{
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        margin: 6px 0;
      }
    }
  }
}
</style>